// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyUnarchiveWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive } from '@zg-rentals/ts-rental-manager-api-beta-client';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-beta-client';

interface UnarchiveParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive_Args {
  getParams: UnarchiveParams;
}

export type RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive_Args
>;

/**
 * Unarchive a listing and its dupes
 */
export const useRentalManagerUserPropertyUnarchiveWebApiHandler_unarchive = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive_Args) =>
      RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive(args.getParams, httpClient),
  });
};
